module.exports = __webpack_public_path__ + "static/uni_virginia-3a13f0edd485d5d1d651c36360c62d6f.png";